import React from 'react';
// import { LanguageSelectionDropdown } from '@weirgroup/one-weir';
import LanguageSelectionDropdown from '../LanguagaeSelector/LanguageSelectionDropDown';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSelection.module.css';

/**
 * Class which includes dropdown for language selection,
 * On selection of particular language is updated throughout the application
 * @usage <LanguageSelection color={string}/>
 */
export default function LanguageSelection(props) {
  const { i18n } = useTranslation();
  /**
   * Triggered while selecting language from the dropdown
   * @param  code
   */
  function selectLanguage(code) {
    i18n.changeLanguage(code);
    props.storeLanguageCode(code);
  }

  const { color, languageCode } = props;
  let defaultLanguageCode = '';
  if (!languageCode) {
    const code = navigator.language.substring(0, 2);
    props.storeLanguageCode(code);
    i18n.changeLanguage(code);
  } else {
    defaultLanguageCode = languageCode;
  }
  const languageCodes = [
    'es',
    'pt',
    'en',
    'ru',
    'zh',
    'nl',
    'fr',
    'tr',
    'pl',
    'za',
    'my',
  ];
  return (
    <>
      {defaultLanguageCode && (
        <div className={styles.languageSelectionDropdown}>
          <LanguageSelectionDropdown
            languageCodes={languageCodes}
            defaultLanguageCode={defaultLanguageCode}
            selectLanguage={selectLanguage}
            color={color}
          />
        </div>
      )}
    </>
  );
}
